import { ProcessosContainer } from "../processos/Processos.container";
export var AppRoutes = {
    "/": ProcessosContainer,
};
